import React, {useEffect, useState} from "react";
import cn from "classnames";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { FormattedMessage } from "react-intl";
import { TableIconCell } from "components/table";
import PropTypes from "prop-types";
import { HeaderCell } from "components/table";
import withStyles from "components/with-styles";
import styles from "./styles/table.css.js";
import { useAuthDataContext } from "components/auth";
import { getScoreboardTemplateImg, getScoreboardTemplateThumbnail } from "config/paths";
import { RadioButton } from "components/form/form-radiobutton";
import Dialog from "components/dialog";
import { useLoadingContext } from "components/loading-spinner-overlay";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TablePagination from "../../../../../components/table/paginated-table/partial/table-pagination";
import Footer from "../../../../../components/table/paginated-table/partial/footer";
import Paper from "@material-ui/core/Paper";
import {getScoreboardTemplatesService} from "../../../../../services/commonService";

const Header = () => (
  <TableRow>
    <TableIconCell />
    <HeaderCell>
      <FormattedMessage id="common.name" />
    </HeaderCell>
    <TableIconCell />
  </TableRow>
);

const Row = ({ item, onClick, selectedRowId, classes, contractId }) => {
  const { token } = useAuthDataContext();
  const [open, setOpen] = useState(false);
  const { setLoading } = useLoadingContext();

  const handleOpen = () => {
    setLoading(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const templateImgUrl = getScoreboardTemplateImg({ contractId, scoreboardTemplateId: item.template_id, token });
  const templateThumbnailUrl = getScoreboardTemplateThumbnail({ contractId, scoreboardTemplateId: item.template_id, token });

  return (
    <TableRow className={cn({ [classes.selectedRow]: selectedRowId === item.template_id })} key={item.template_id}>
      <TableCell>
        <img onClick={handleOpen} className={classes.scoreboardTemplate_thumbnail} src={templateThumbnailUrl} alt="Scoreboard template thumbnail" />
        <Dialog showCloseButton open={open} onClose={handleClose}>
          <img className={classes.scoreboardTemplate_preview} onLoad={() => setLoading(false)} src={templateImgUrl} alt="Scoreboard template thumbnail" />
        </Dialog>
      </TableCell>
      <TableCell>{item.codename}</TableCell>
      <TableIconCell>
        <RadioButton
          value={item.template_id}
          checked={selectedRowId === item.template_id}
          onClick={onClick}
        />
      </TableIconCell>
    </TableRow>
  );
};

Row.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
  /**
   * Id del contrato
   **/
  contractId: PropTypes.string,
  /**
   * Id de la fila seleccionada
   **/
  selectedRowId: PropTypes.string,
  /**
   * Callback opcional de click en la fila
   **/
  onClick: PropTypes.func,
};

const StyledRow = withStyles(styles)(Row);

const ScoreboardTemplatesTable = ({ classes, contractId, eventTypeId, scoreboardIdSelected, setScoreboardIdSelected, setScoreboardNameSelected }) => {
  const [scoreboardTemplates, setScoreboardTemplates] = useState([]);

  const scoreboardTypesCallback = (response) => {
      setScoreboardTemplates(response);
  }

  const getScoreboardTemplates = () => {
      getScoreboardTemplatesService(contractId, eventTypeId, scoreboardTypesCallback);
  };

  useEffect(() => {
      if (contractId && eventTypeId) {
          getScoreboardTemplates();
      }
  }, [contractId, eventTypeId]);

  return <Paper elevation={2} className={cn(classes.paginatedtable)}>
    <Table>
      <TableHead>
        <Header />
      </TableHead>
      <TableBody>
        {scoreboardTemplates?.map((item, index) => (
            <StyledRow
                key={item._id || index}
                item={item}
                onClick={() => {
                  if (scoreboardIdSelected === item.template_id) {
                    setScoreboardIdSelected(null);
                    setScoreboardNameSelected(null);
                  } else {
                    setScoreboardIdSelected(item.template_id);
                    setScoreboardNameSelected(item.codename);
                  }
                }}
                contractId={contractId}
                selectedRowId={scoreboardIdSelected}
            />
        ))}
        {Array.isArray(scoreboardTemplates) && !scoreboardTemplates.length && (
            <TableRow>
              <TableCell />
            </TableRow>
        )}
      </TableBody>
    </Table>
  </Paper>
}

ScoreboardTemplatesTable.propTypes = {
  /**
   ** Objeto que contiene los filtrados de la búsqueda
   **/
  variables: PropTypes.object,
  /**
   * Debouncea o no la recarga de la query de la tabla
   **/
  debounce: PropTypes.bool,
};

export default withStyles(styles)(ScoreboardTemplatesTable);
